import React, { useEffect } from "react";
import qs from "qs";
import { resetToken } from "API";

export enum ClientType {
    Dufe = "0"
}

const PageBridge: React.FC = () => {
    useEffect(() => {
        const { token, refresh_token, redirect_url } = qs.parse(
            window.location.search,
            { ignoreQueryPrefix: true }
        );

        const encodeToken = atob(token?.toString() || "");
        const encodeRefreshToken = atob(refresh_token?.toString() || "");
        const redirectUrl = atob(redirect_url?.toString() || "");
        localStorage.clear();

        resetToken(encodeToken, encodeRefreshToken).then(res => {
            localStorage.setItem("token", res.token);
            localStorage.setItem("user", res.studentNo);
            localStorage.setItem("userType", res.type);
            localStorage.setItem("clientType", ClientType.Dufe);
            window.location.href = redirectUrl;
        });

        // http://localhost:3000/bridge?token=ZXlKaGJHY2lPaUpJVXpJMU5pSjkuZXlKcWRHa2lPaUpxZDNSZmRHOXJaVzRpTENKcFlYUWlPakUxT1RRNU5USTRNelVzSW5OMVlpSTZJbnRjSW5WelpYSkRiMlJsWENJNlhDSmpaWE5vYVRBeFhDSXNYQ0p2Y21kRGIyUmxYQ0k2WENKaVoza3RjM1IxWENKOUlpd2laWGh3SWpveE5UazBPVFV5T0RrMWZRLmZCUUFNQTBPS2NiVmpFWnkxUWhfS0ptUzJjZDJHTnktZnZ3bV83d1pWOXM&refresh_token=ZXlKaGJHY2lPaUpJVXpJMU5pSjkuZXlKcWRHa2lPaUpxZDNSZmRHOXJaVzRpTENKcFlYUWlPakUxT1RRNU5USTRNelVzSW5OMVlpSTZJbnRjSW5WelpYSkRiMlJsWENJNlhDSmpaWE5vYVRBeFhDSXNYQ0p2Y21kRGIyUmxYQ0k2WENKaVoza3RjM1IxWENKOUlpd2laWGh3SWpveE5UazFNRE01TWpNMWZRLlJCd1I3b3dZNFRuVFNoMVpMMnJKcTVsbkFqMUM3VFE4d3RneGVUdG1TY00&redirect_url=Lw==
    }, []);

    return null;
};

export default PageBridge;
